module.exports = __webpack_public_path__ + "static/media/05_overseas_mobile.01cb6240.mp4";